export default __webpack_public_path__ + "static/media/pie.4b8422d7.svg";